import { Navigate, useLocation } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "@/lib/auth-provider";
import { Loading } from "./loading";

export function EditorRoute({ children }: { children: ReactNode }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loading />;

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (!profile || !["admin", "manager"].includes(profile.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
